// @flow

import type {ReduxActionType} from "../../flow/ReduxActionType";

/**
 * Load aiSettings
 * @type: Action
 */
export const aiSettingsLoad = (domain_id: number): ReduxActionType => ({
    type: 'AI_SETTINGS_LOAD',
    payload: { domain_id },
});

/**
 * AiSettings loaded
 * @type: Event
 */
export const aiSettingsLoaded = (settings: {}): ReduxActionType => ({
    type: 'AI_SETTINGS_LOADED',
    payload: settings ,
});

/**
 * Change input content
 * @type: Action
 */
export const aiSettingsChangeInput = (name: string, value: all, type: string): ReduxActionType => ({
    type: 'AI_SETTINGS_CHANGE_INPUT',
    payload: { name, value, type },
});

/**
 * Add a AiSettings sub item
 * @type: Action
 */
export const aiSettingsSubAdd = (type: string, index: number | void): ReduxActionType => ({
    type: 'AI_SETTINGS_SUB_ADD',
    payload: { type , index },
});

/**
 * Add a AiSettings sub item
 * @type: Action
 */
export const aiSettingsSubDelete = (type: string, index: number | void): ReduxActionType => ({
    type: 'AI_SETTINGS_SUB_DELETE',
    payload: { type , index },
});

/**
 * Save a AiSettings
 * @type: Action
 */
export const aiSettingsSave = (domain_id: number): ReduxActionType => ({
    type: 'AI_SETTINGS_SAVE',
    payload: {domain_id},
});

/**
 * AiSettings has been saved
 * @type: Event
 */
export const aiSettingsSaved = (settings): ReduxActionType => ({
    type: 'AI_SETTINGS_SAVED',
    payload: settings,
});

/**
 * AiSettings request failed
 * @type: Event
 */
export const aiSettingsRequestFailed = (): ReduxActionType => ({
    type: 'AI_SETTINGS_REQUEST_FAILED',
    payload: null,
});
